import React, { useEffect } from 'react';
import { Panel } from 'rsuite';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import {
  getAll as getGuestAuditLogs,
  getIsFetched
} from '../../../../redux/Guest/selectors/audit-log';
import { getClientColumnsByName } from '../../../../redux/selectors/client';
import { fetchGuestAuditLogs } from '../../../../redux/sagas/routines';
import AuditLogList from '../../../../components/guest/AuditLogList';

const AuditSection = ({ guestId, ...props }) => {
  const dispatch = useDispatch();
  const auditLogs = useSelector(getGuestAuditLogs);
  const isFetched = useSelector(getIsFetched);
  const columns = useSelector(getClientColumnsByName);
  useEffect(
    () => {
      if (!guestId || isFetched) return;
      dispatch(fetchGuestAuditLogs({ guestId }));
    },
    [guestId]
  );

  return (
    <Panel {...props}>
      {auditLogs && (
        <AuditLogList guestId={guestId} data={auditLogs} columns={columns} />
      )}
    </Panel>
  );
};

AuditSection.propTypes = {
  guestId: PropTypes.number.isRequired
};

export default AuditSection;
